// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"3ebe7cd6","149":"c6dc953b","189":"f1c284ae","397":"60ccf500","424":"308baa24","490":"f0cfc6f1","518":"85bda768","667":"a34e21f8","781":"6e4c926f"}[chunkId] + ".chunk.js";
};